export default class PrevadzkovaKnihaZaznamModalCtrl {

  constructor($uibModalInstance, typOptions, data){
    this.dialog = $uibModalInstance;
    this.item = {
      typ: (typOptions[0]||{}).value,
      data: Object.assign({}, data)
    };
    this.typOptions = typOptions;
  } 

  isZaznamRequired(){
    switch(this.item.typ){
      case 0:
      case 1:
        return this.item.data.bezZavad == false;
      case 2:
      case 3:
      case 4:
        return true;
    }
    return false;
  }


  ok(){
    this.error = false;
    if(this.item.typ == null){
      this.error = "Musíte zvoliť typ záznamu";
    }
    if(this.item.data.pocitadloPoplachov == null){
      this.error = "Počítadlo poplachov je povinná položka"
    }
    if(this.item.typ == 0 || this.item.typ == 1){
      if(this.item.data.bezZavad == null){
        this.error = "Musíte zvoliť výsledok kontroly: bez závad alebo záznam"
      }
    }
    if(this.isZaznamRequired()){
      if(!this.item.data.zaznam || this.item.data.zaznam.length == 0){
        this.error = "Musite zadať text záznamu"
      }
    }
    if(this.item.typ == 1){
      var entries = ["bateria", "vystupy", "hlasic", "linka"];
      entries.forEach(e => {
        if(!this.item.data.kontrola || this.item.data.kontrola[e] === undefined){
          this.error = "Musíte zadať všetky výsledky kontroly"
        }
      })
    }

    if(!this.error){
      this.dialog.close(this.item);
    }
  }

  cancel(){
    this.dialog.dismiss("cancel");
  }
}


// WEBPACK FOOTER //
// ./src/prevadzkova-kniha/PrevadzkovaKnihaZaznamModalCtrl.js